export const SET_ATHLETE = "SET_ATHLETE";

export const setAthlete = (athlete) => ({
  type: SET_ATHLETE,
  payload: athlete,
});
